
import { getCurrentInstance, computed } from '@vue/composition-api'

export default function useCostPivot () {
    const vm = getCurrentInstance().proxy
    const STORE_KEY = '$_costPivot'
    const store = vm.$store
    const costPivotUserTags = computed(() => store.getters[`${STORE_KEY}/costPivotUserTags`].map(tag => {
        return {
            key: tag,
            name: tag,
            type: 'resource'
        }
    }))
    const attributeDefaultItems = computed(() => ([
        {
            key: 'ym',
            name: 'YM',
            type: 'default'
        },
        {
            key: 'ymd',
            name: 'YMD',
            type: 'default'
        },
        {
            key: 'w',
            name: 'W',
            type: 'default',
            removeFilter: true
        },
        {
            key: 'd',
            name: 'D',
            type: 'default',
            removeFilter: true
        },
        {
            key: 'group',
            name: 'Group',
            type: 'default'
        },
        {
            key: 'usageAccountId',
            name: 'AWS Account',
            type: 'default'
        },
        {
            key: 'productCode',
            name: 'Product',
            type: 'default'
        },
        {
            key: 'productCategory',
            name: 'Product Category',
            type: 'default'
        },
        {
            key: 'region',
            name: 'Region',
            type: 'default'
        },
        {
            key: 'lineItemType',
            name: 'LineItem Type',
            type: 'default'
        },
        {
            key: 'instanceType',
            name: 'Instance Type',
            type: 'default'
        }
    ]))
    const attributeDescriptionItems = computed(() => ([
        {
            key: 'usageType',
            name: 'Usage Type',
            type: 'description'
        },
        {
            key: 'operation',
            name: 'Operation',
            type: 'description'
        },
        {
            key: 'lineItemDescription',
            name: 'LineItem Description',
            type: 'description',
            removeFilter: true
        },
        {
            key: 'reservedInstancesId',
            name: 'Reserved InstancesId',
            type: 'description'
        },
        {
            key: 'savingsPlan_savingsPlanArn',
            name: 'SavingsPlanARN',
            type: 'description'
        },
        {
            key: 'unblendedRate',
            name: 'Unblended Rate',
            type: 'description'
        }
    ]))
    const attributeResourceItems = computed(() => ([
        {
            key: 'resourceId',
            name: 'ResourceId',
            type: 'resource'
        },
        ...costPivotUserTags.value
    ]))
    const pivotValues = computed(() => ([
        {
            name: 'Value: Cost ($)',
            value: 'unblendedCost'
        },
        {
            name: 'Value: Usage',
            value: 'usageAmount'
        },
        {
            name: 'Value: SavingsPlan Total Commitment',
            value: 'savingsPlan_totalCommitment'
        },
        {
            name: 'Value: SavingsPlan Used Commitment',
            value: 'savingsPlan_usedCommitment'
        },
        {
            name: 'Value: SavingsPlan Effective cost',
            value: 'savingsPlan_effectiveCost'
        }
    ]))
    const getCompositSources = (rows = [], cols = []) => {
        return rows.concat(cols).sort()
    }
    const locales = {
        en: {
            localeStrings: {
                renderError: 'An error occurred rendering the PivotTable results.',
                computeError: 'An error occurred computing the PivotTable results.',
                uiRenderError: 'An error occurred rendering the PivotTable UI.',
                selectAll: 'Select All',
                selectNone: 'Select None',
                tooMany: 'too many values to show',
                filterResults: 'Filter values',
                totals: 'Totals',
                only: 'only',
                vs: 'vs',
                by: 'by'
            }
        },
        ja: {
            localeStrings: {
                renderError: 'An error occurred rendering the PivotTable results.',
                computeError: 'An error occurred computing the PivotTable results.',
                uiRenderError: 'An error occurred rendering the PivotTable UI.',
                selectAll: 'Select All',
                selectNone: 'Select None',
                tooMany: 'too many values to show',
                filterResults: 'Filter values',
                totals: 'Totals',
                only: 'only',
                vs: 'vs',
                by: 'by'
            }
        },
        ko: {
            localeStrings: {
                renderError: '피벗 테이블 결과를 렌더링하는 동안 오류가 발생 했습니다.',
                computeError: '피벗 테이블 결과를 계산하는 동안 오류가 발생 했습니다.',
                uiRenderError: '피벗 테이블 UI를 렌더링하는 동안 오류가 발생 했습니다.',
                selectAll: '모두 선택',
                selectNone: '선택 안함',
                tooMany: '표시 할 값이 너무 많습니다.',
                filterResults: '값 필터링',
                totals: '합계',
                only: '단독',
                vs: 'vs',
                by: 'by'
            }
        }
    }
    return {
        locales,
        pivotValues,
        attributeDefaultItems,
        attributeDescriptionItems,
        attributeResourceItems,
        getCompositSources
    }
}
